<template>
  <div class="grid-y flex-grow divide-y">
    <div class="flex-shrink-0 container-tabs padding-horizontal-2 flex flex-row justify-between">
      <RouterTabs :tabs="tabsWithCounters"/>
      <div class="flex items-center">
        <template v-if="(tabStatuses && tabStatuses.length > 1) && tab !== 'promocodes'">
          <small class="mr-4">Сортировать по статусу:</small>
          <div class="badges flex flex-row">
            <div
              :key="badge.status"
              class="badge cursor-pointer"
              :class="[
                `badge bg-${badge.badge}`,
                {
                  'bg-muted': !thisTabFilterStatuses.includes(badge.status),
                },
              ]"
              v-for="badge in tabStatuses"
              @click="selectFilterStatus(badge)">
              {{ badge.name }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="cell auto flex">
      <div class="grid-x flex-grow">
        <div class="cell auto cell-block-y flex flex-grow">
          <router-view
            :tab="tab"
            :statuses="statuses"
            :query="query"
            :order-by.sync="orderBy"
            :uid="$route.name">
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import RouterTabs from '@/components/RouterTabs.vue';
import { mapActions, mapState } from 'vuex';
import { ADMIN_PERMISSIONS, canAccess } from '@/access/adminAccess';

export default {
  components: {
    RouterTabs,
  },
  data() {
    return {
      tabs: [
        { title: 'Активные', push: { name: 'orders.active' } },
        { title: 'Завершенные', push: { name: 'orders.completed' } },
        { title: 'Споры', push: { name: 'orders.dispute' } },
        { title: 'Промокоды', push: { name: 'orders.promocodes' } },
      ],
      query: '',
      orderBy: [],
    };
  },
  computed: {
    ...mapState({
      filterStatuses: (state) => state.orders.filterStatuses,
      disputeCount: (state) => state.orders.disputeCount,
      user: (state) => state.auth.user,
    }),
    tabsWithCounters() {
      return this.tabs
        .filter((tab) => (_.get(tab, 'push.name') !== 'orders.promocodes'
          || canAccess(this.user, ADMIN_PERMISSIONS.SETTINGS)))
        .map((tab) => {
          if (_.get(tab, 'push.name') === 'orders.dispute') {
            return {
              ...tab,
              badge: this.disputeCount,
            };
          }
          return tab;
        });
    },
    tab() {
      return this.$route.name.split('.').filter((s) => s !== 'orders')[0];
    },
    tabStatuses() {
      switch (this.tab) {
        case 'active':
          return [
            { name: 'Новый', status: 'draft', badge: 'gray-600' },
            { name: 'Активный', status: 'active', badge: 'primary' },
            { name: 'Назначен', status: 'assigned', badge: 'info' },
            { name: 'В работе', status: 'in_work', badge: 'warning' },
            { name: 'Повторный', status: 'contractor_invited', badge: 'warning' },
          ];
        case 'completed':
          return [
            { name: 'Выполнен', status: 'completed', badge: 'primary' },
            { name: 'Завершен', status: 'closed', badge: 'primary' },
            { name: 'Отменен', status: 'cancelled', badge: 'danger' },
          ];
        case 'dispute':
          return [
            { name: 'Спор', status: 'dispute', badge: 'danger' },
          ];
        case 'promocodes':
          return [
            { name: 'Активный', status: 'active', badge: 'primary' },
            { name: 'Отменен', status: 'cancelled', badge: 'danger' },
          ];
        default:
          return [];
      }
    },
    thisTabFilterStatuses() {
      return _.get(this.filterStatuses, this.tab) || [];
    },
    statuses() {
      if (!this.thisTabFilterStatuses.length) {
        return this.tabStatuses.map((obj) => obj.status);
      }
      return this.thisTabFilterStatuses;
    },
  },
  watch: {
    tab: {
      handler() {
        this.query = '';
        this.orderBy = [];
        this.$eventBus.$emit('find.order.value', this.query);
      },
    },
  },
  methods: {
    ...mapActions({
      setFilterStatuses: 'orders/ACT_SET_STATUSES',
      unsetFilterStatuses: 'orders/ACT_UNSET_STATUSES',
      fetchDisputeCount: 'orders/ACT_FETCH_DISPUTE_COUNT',
    }),
    selectFilterStatus({ status }) {
      this.setFilterStatuses({
        key: this.tab,
        status,
      });
      this.query = '';
      this.$eventBus.$emit('find.order.value', this.query);
    },
  },
  mounted() {
    this.fetchDisputeCount();
    this.$eventBus.$on('find.order', (data) => {
      if (data !== '') {
        this.unsetFilterStatuses({
          key: this.tab,
        });
      }
      this.query = data;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('find.order');
  },
};
</script>
